import * as marked from 'marked';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'snMarked',
})
export class SnMarkedPipe implements PipeTransform {
  public transform(str: string): any {
    const renderer = new marked.Renderer();
    renderer.link = (href, title, text) =>
      `<a target="_blank" href="${href}" title="${title}">${text}</a>`;
    return marked.parseInline(str, { renderer });
  }
}
